enum WorkspaceProjectCarbonRemovalPoolType {
  carbon_dioxide = 'carbon_dioxide',
  percentage = 'percentage',
}

export default WorkspaceProjectCarbonRemovalPoolType
